import { Navigate } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Avatar, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Subscribe from '../Components/Subscribe';
import useLoggedIn from '../hooks/useLoggedIn';
import useUserData from '../hooks/useUserData';

export default function SignIn() {

  const { loggedIn, onSignIn } = useLoggedIn();
  const { isBeta, locale, zoneInfo, ibAdminCode, ibTimeOffset, loading } = useUserData();

  return (

    <Container component="main" >
      {loggedIn ?
        <Navigate to="/" replace={true} />
        :
        <Grid container direction="column" spacing={2} mt={2} justifyContent="center" display='flex' alignItems='center'>
          <Grid item lg={6} xs={12}>
            <Card>
              <CardContent>
                <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                  <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                    <LockOutlinedIcon />
                  </Avatar>
                </Container>

                <Authenticator hideSignUp={true} >
                  {({ signOut, user }) => (
                    <main>
                      {onSignIn()}

                    </main>
                  )}
                </Authenticator>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      }

      <Grid container direction="column" spacing={2} mt={2} justifyContent="center" display='flex' alignItems='center'>
        <Grid item lg={6} xs={12}>
          <Typography
            variant="body1"
            color='secondary'
            sx={{ mb: 3 }}
          >Don't have an account yet? Create one by clicking on the link below.</Typography>
          <Subscribe color='success' />
        </Grid>
      </Grid>
    </Container>
  );
}